import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=279fdb4a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279fdb4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279fdb4a')) {
      api.createRecord('279fdb4a', component.options)
    } else {
      api.reload('279fdb4a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=279fdb4a&scoped=true&", function () {
      api.rerender('279fdb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KHYc7o3F7gYz/JS/comp/SearchFilterTokens.vue"
export default component.exports